import {
  AfterViewInit,
  Directive,
  ElementRef,
  inject,
  Input,
  OnDestroy,
  output,
} from '@angular/core';

@Directive({
  selector: '[enterTheViewportNotifier]',
  standalone: true,
})
export class EnterTheViewportNotifierDirective
  implements AfterViewInit, OnDestroy
{
  private _elementRef = inject(ElementRef);

  @Input() parent: any;
  visibilityChange = output<string>();
  private _observer?: IntersectionObserver;

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {}

  ngAfterViewInit(): void {
    const options = { root: null, rootMargin: '0px', threshold: 0.0 };
    this._observer = new IntersectionObserver(this._callback, options);
    this._observer.observe(this._elementRef.nativeElement);
  }

  ngOnDestroy() {
    this._observer?.disconnect();
  }

  private _callback = (entries: any, observer: any) => {
    entries.forEach((entry: any) =>
      this.visibilityChange.emit(entry.isIntersecting ? 'VISIBLE' : 'HIDDEN'),
    );
  };
}
